import { c as _c } from "react/compiler-runtime";
import { CurrencyFormatter } from "@sticker-giant/sg-frontend-common";
import { Skeleton } from "@/components/ui/skeleton";
import { getItemPrice } from "@/lib/product/pricing";
import { getQuantityOptionsForMaterial, isSoleQuantityOne } from "@/lib/product/quantities";
import { useProduct } from "@/queries/useProduct";
import { useCustomQuantityPricing, useQuantityPricing } from "@/queries/useQuantityPricing";
import { usePdpStore } from "@/stores/usePdpStore";
import { useProductBuilderContext } from "./ProductBuilderContext";
export default function TotalPrice() {
  const $ = _c(17);
  const {
    product
  } = useProductBuilderContext();
  const {
    data: productAdmin,
    isFetching: isProductFetching
  } = useProduct(product.sku);
  const selectedQuantity = usePdpStore(_temp);
  const {
    data: pricingData,
    isFetching: isPricingFetching
  } = useQuantityPricing(productAdmin);
  const {
    data: customPricingData,
    isFetching: isCustomPricingFetching
  } = useCustomQuantityPricing(productAdmin);
  const material = usePdpStore(_temp2) ?? productAdmin?.defaultMaterial;
  const quantityOptions = productAdmin ? getQuantityOptionsForMaterial(productAdmin, material) : [];
  const showTotal = selectedQuantity || isSoleQuantityOne(quantityOptions);
  if (!showTotal) {
    return null;
  }
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== customPricingData || $[1] !== isCustomPricingFetching || $[2] !== isPricingFetching || $[3] !== isProductFetching || $[4] !== pricingData || $[5] !== selectedQuantity) {
    t4 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const totalPrice = selectedQuantity ? getItemPrice(selectedQuantity, pricingData, customPricingData) : undefined;
      const isLoading = !totalPrice && (isProductFetching || isPricingFetching || isCustomPricingFetching);
      if (isLoading) {
        let t5;
        if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
          t5 = <Skeleton className="h-4 w-28" />;
          $[11] = t5;
        } else {
          t5 = $[11];
        }
        t4 = t5;
        break bb0;
      }
      if (!totalPrice) {
        t4 = null;
        break bb0;
      }
      t0 = "polite";
      t1 = "text-base font-bold leading-none tabular-nums text-foreground";
      t2 = "Total: ";
      t3 = CurrencyFormatter.formatUSD(totalPrice);
    }
    $[0] = customPricingData;
    $[1] = isCustomPricingFetching;
    $[2] = isPricingFetching;
    $[3] = isProductFetching;
    $[4] = pricingData;
    $[5] = selectedQuantity;
    $[6] = t0;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t0 = $[6];
    t1 = $[7];
    t2 = $[8];
    t3 = $[9];
    t4 = $[10];
  }
  if (t4 !== Symbol.for("react.early_return_sentinel")) {
    return t4;
  }
  let t5;
  if ($[12] !== t0 || $[13] !== t1 || $[14] !== t2 || $[15] !== t3) {
    t5 = <p aria-live={t0} className={t1}>{t2}{t3}</p>;
    $[12] = t0;
    $[13] = t1;
    $[14] = t2;
    $[15] = t3;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  return t5;
}
function _temp2(state_0) {
  return state_0.material;
}
function _temp(state) {
  return state.quantity;
}